import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { FormControl, FormLabel, SimpleGrid } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { TargetSystemVersionFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * 編集モーダル用のシステムの次回バージョンのフォームです。
 */
export const TargetSystemVersionForm: FC<Props> = ({ register }) => (
  <FormControl>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>システムの次回バージョン</FormLabel>
      <TargetSystemVersionFormBase register={register} />
    </SimpleGrid>
  </FormControl>
);
